import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrl: './modal-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalDialogComponent {
  title = input.required();
  dismiss = output();

  dismissClick(): void {
    this.dismiss.emit();
  }
}
